import ClientStore from './ClientStore';

export default new ClientStore(sessionStorage);
